(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    const playBtn = e.target.closest('[ref="deferredMediaPlayButton"]');
    if (!playBtn) return;

    const deferredMedia = playBtn.closest('deferred-media');
    if (!deferredMedia) return;

    // Small delay to let the iframe load into the DOM
    setTimeout(function () {
      const iframe = deferredMedia.querySelector('iframe.js-youtube');
      if (!iframe) return;

      // Wait for YouTube JS API to initialise, then unmute
      const tryUnmute = setInterval(function () {
        try {
          iframe.contentWindow.postMessage(
            JSON.stringify({ event: 'command', func: 'unMute', args: [] }),
            '*'
          );
          iframe.contentWindow.postMessage(
            JSON.stringify({ event: 'command', func: 'setVolume', args: [100] }),
            '*'
          );
          clearInterval(tryUnmute);
        } catch (err) {
          // iframe not ready yet, keep trying
        }
      }, 300);

      // Stop trying after 3 seconds to avoid an infinite loop
      setTimeout(function () { clearInterval(tryUnmute); }, 3000);
    }, 200);
  });
  } catch(e) { console.error(e); }
})();

})();
